import React, { useContext  } from "react";
import { OrdersContext } from "../../context/OrdersContext";
import { Select, Card, Col, Row, DatePicker, Empty } from "antd";
import { statusList } from "../../utils";
import { ComparativeLocations } from "./components/Sale/ComparativeLocations";
import { ChartSeller } from "./components/Sale/ChartSeller";
import { ChannelPie } from "./components/Sale/ChannelPie";
import { ChartChannel } from "./components/Sale/ChartChannel";
import { ChartChannelComparative } from "./components/Sale/ChartChannelComparative";

const { Option } = Select;
const { RangePicker } = DatePicker;

const dateFormat = "DD-MM-YYYY";

const statusOptions = statusList ? Object.keys(statusList) : [];

const BoardSaleTwo = () => {

  const {
    filteredOrdersByStart,
    statusFilter,
    dateFilter,
    isLoadingSales,
    isLoadingOrders,
    isLoadingDateFilteredData,
    setStatusFilter,
    setDateFilter, } = useContext(OrdersContext);
  const isLoading =
    isLoadingSales || isLoadingOrders || isLoadingDateFilteredData;

  if (isLoading) {
    return (
      <div style={{ marginTop: 40, marginLeft: 20 }}>Cargando ventas...</div>
    );
  } else {
    return (
      <div className="flex justify-center h-fit">
        <div className="grid-rows-custom grid-cols-custom gap-x-0 gap-y-0 m-5 w-full xl:w-11/12">
          <div>
            <div
            className="flex justify-end"
            >
              <div className="mr-5 w-80 pb-4">
                <RangePicker
                  value={dateFilter}
                  onChange={(dates) => setDateFilter(dates)}
                  format={dateFormat}
                />
              </div>
              <div>
                <Select
                  mode="multiple"
                  value={
                    statusFilter.length ? statusFilter : ["Todos los estados"]
                  }
                  onChange={(value) => {
                    if (
                      value.includes("Todos los estados") &&
                      statusFilter.length === 1
                    ) {
                      setStatusFilter(["Todos los estados"]);
                    } else {
                      setStatusFilter(
                        value.filter((item) => item !== "Todos los estados")
                      );
                    }
                  }}
                  style={{ minWidth: 200 }}
                >
                  <Option disabled value="Todos los estados">
                    Todos los estados
                  </Option>
                  {statusOptions?.map((option) => (
                    <Option key={option} value={option}>
                      {option}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </div>
          <div className="">
            <Row className="flex flex-col lg:flex-row" gutter={16}>
              <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={12}>
                <ComparativeLocations data={filteredOrdersByStart} />
              </Col>
              <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={12}>
                <ChartSeller data={filteredOrdersByStart} />
              </Col>
            </Row>
          </div>
          <div className="">
          <Row className="flex flex-col lg:flex-row" gutter={16}>
            <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={8}>
                {filteredOrdersByStart.length > 0 ? (
                  <ChannelPie data={filteredOrdersByStart} />
                ) : (
                  <Card title="Canales">
                    <div
                      style={{
                        height: 300,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Empty description="No hay datos disponibles" />
                    </div>
                  </Card>
                )}
              </Col>
              <Col className="pb-4" xs={24} sm={24} md={24} lg={24} xl={16}>
                <ChartChannel data={filteredOrdersByStart} />
              </Col>
            </Row>
          </div>
          <div className="">
            <Row gutter={16}>
              <Col span={24}>
                {filteredOrdersByStart.length > 0 ? (
                  <ChartChannelComparative data={filteredOrdersByStart} />
                ) : (
                  <Card title="Comparativa de Ventas por Canal">
                    <div
                    className="h-80 flex justify-center items-center"
                      
                    >
                      <Empty description="No hay datos disponibles" />
                    </div>
                  </Card>
                )}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    );
  }
};

export default BoardSaleTwo;
